import { useEffect as useEffectHook } from 'react';
import { debounce } from 'helper/util';

export const useEffect = (cb, dependencies = []) => {
    const fun = debounce(() => {
        cb();
    }, 1000);

    useEffectHook(() => {
        fun();
    }, dependencies)
};
